import { Collection, CollectionType } from './Collection';

export default class Queue extends Collection {
    constructor() {
        super(CollectionType.FIFO);
    }
}